import { memo } from 'react';
import { FeatureFlagEnum } from '../../../../../../../../featureflag/feature-flag.enum';
import { useGetProductColorSelloutMetrics } from '../../../../../../../../services/modules/product-color-sellout/product-color-sellout.queries';
import { getProductColorSellout } from '../../../../../../../../services/modules/product-color-sellout/productColorSellout.utils';
import useSystemParametersStore from '../../../../../../../../stores/SystemParameters/useSystemParameters.store';
import SelloutModal from './modal/components/SelloutModal';

interface SelloutMenuProps {
  isOpen: boolean;
  onClose: () => void;
  readMode: boolean;
  orderId?: string;
  productColorId: string;
}

const SelloutMenu = ({ isOpen, onClose, readMode, orderId, productColorId }: SelloutMenuProps) => {
  const { getBrandSystemParameterValue } = useSystemParametersStore();
  const sellout = useGetProductColorSelloutMetrics({ orderId, productColorId });

  const selloutData = getProductColorSellout({
    isFetching: sellout.isFetching,
    metrics: sellout.data ?? undefined,
    minValue: getBrandSystemParameterValue(FeatureFlagEnum.COMMERCE_MIN_VALUE_TO_SHOW_SELLOUT_TAG),
  });

  if (!selloutData) {
    return null;
  }

  return (
    <SelloutModal isOpen={isOpen} onClose={onClose} readMode={readMode} selloutData={selloutData} />
  );
};

export default memo(SelloutMenu);
